import { UserModel, UserPayload } from '../../../../types/User';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { LocationModel } from '../../../../types/Location';

export const prepareUpdateUser = ({
    userElement,
    payload,
    locationElement,
}: {
    userElement: UserModel;
    payload: UserPayload;
    locationElement?: LocationModel;
}) =>
    userElement.prepareUpdate((user) => {
        user.firstName = payload.hasOwnProperty('firstName')
            ? payload.firstName
            : userElement.firstName;
        user.lastName = payload.hasOwnProperty('lastName')
            ? payload.lastName
            : userElement.lastName;
        user.companyName = payload.hasOwnProperty('companyName')
            ? payload.companyName
            : userElement.companyName;
        user.phone = payload.hasOwnProperty('phone')
            ? payload.phone
            : userElement.phone;
        user.phonePrefix = payload.phonePrefix || userElement.phonePrefix;
        user.accountingProvider = payload.hasOwnProperty('accountingProvider')
            ? payload.accountingProvider
            : userElement.accountingProvider;
        user.accountingDisconnectMessage =
            payload.accountingDisconnectMessage ||
            userElement.accountingDisconnectMessage;
        user.region = payload.region || userElement.region;
        user.address = payload.hasOwnProperty('address')
            ? payload.address
            : userElement.address;
        user.locationId = locationElement?.id
            ? locationElement.id
            : user.locationId;
        user.menuOrder = payload.menuOrder ?? user.menuOrder;
        user.freshchatRestoreId =
            payload.freshchatRestoreId ?? user.freshchatRestoreId;
        user.isTeamCreated = payload.isTeamCreated ?? user.isTeamCreated;
        user.timezone = payload.timezone ?? user.timezone;
        user.isProceduresAccountSetupSet =
            payload.isProceduresAccountSetupSet ??
            user.isProceduresAccountSetupSet;
        user.isInvoicingAccountSetupSet =
            payload.isInvoicingAccountSetupSet ??
            user.isInvoicingAccountSetupSet;
        user.isContactsSetup = payload.isContactsSetup ?? user.isContactsSetup;
        user.isAppointmentOnboarded =
            payload.isAppointmentOnboarded ?? user.isAppointmentOnboarded;
        user.isAppointmentContactSelectionOnboarded =
            payload.isAppointmentContactSelectionOnboarded ??
            user.isAppointmentContactSelectionOnboarded;
        user.isEntryCreationFromEventEnabled =
            payload.isEntryCreationFromEventEnabled ??
            user.isEntryCreationFromEventEnabled;
        user.termsAcceptedAt = payload.termsAcceptedAt || user.termsAcceptedAt;
        user.isPlusButtonOnboarded =
            payload.isPlusButtonOnboarded ?? user.isPlusButtonOnboarded;
    });

export const prepareUpdateUserField = ({
    userElement,
    fieldName,
    fieldValue,
}: {
    userElement: UserModel;
    fieldName: string;
    fieldValue: string | number | boolean;
}) =>
    userElement.prepareUpdate((user) => {
        user[fieldName] = fieldValue;
    });

export const prepareSetUserProfiling = ({
    userElement,
    value,
    traceID,
}: {
    userElement: UserModel;
    value: boolean;
    traceID: string;
}) =>
    userElement.prepareUpdate((user) => {
        user.profiling = value;
        user.traceID = traceID;
    });

export const logUpdateUserAction = ({
    user,
    logDBAction,
    message,
    tableName,
}: {
    user: UserModel;
    logDBAction: DBWriterLoggerFunction;
    message: string;
    tableName: string;
}) => {
    logDBAction({
        message,
        modelName: tableName,
        payload: user,
    });
};
